import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NZ_MODAL_DATA, NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { FabricVariationModel } from '../../../../shared/models/fabric-variation.model';
import { CustomCurrencyPipe } from '../../../../shared/pipes/custom-currency.pipe';
import { TranslatePipe } from '../../../../shared/pipes/translate.pipe';
import { fallbackImage } from '../../../../shared/utils/image.util';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { FabricVariationService } from '../../../../shared/services/fabric-variation.service';
import { CleanInstructionModel } from '../../../../shared/models/clean-instruction.model';

@Component({
  selector: 'app-fabric-compare-modal',
  standalone: true,
  imports: [
    CommonModule,
    NzButtonModule,
    NzImageModule,
    NzModalModule,
    NzSpinModule,
    CustomCurrencyPipe,
    TranslatePipe,
    RouterLink,
  ],
  templateUrl: './fabric-compare-modal.component.html',
  styleUrls: ['./fabric-compare-modal.component.scss'],
})
export class FabricCompareModalComponent extends ModalComponent<FabricVariationService> {
  readonly fabricUUIDs: string[];
  readonly compareRowLabels: string[] = [
    'Price range',
    'Structure',
    'Weaving type',
    'Weight (+/- 5%)',
    'Width (+/- 5%)',
    'Fabric state',
    'Color',
    'MOQ',
    'Composition',
    'Wash care',
    'Certifications',
  ];
  fabrics: FabricVariationModel[] = [];

  readonly fallback = fallbackImage;

  constructor(
    @Inject(NZ_MODAL_DATA) data: { fabricUUIDs: string[] },
    override readonly modalRef: NzModalRef,
    private readonly fabricVariationService: FabricVariationService
  ) {
    super(data, modalRef, fabricVariationService);

    this.fabricUUIDs = data?.fabricUUIDs ?? [];

    this.modalRef.updateConfig({ nzWidth: Math.min(270 + this.fabricUUIDs.length * 200, 900) });
  }

  setForm(): void {
    // No form in this modal
  }

  override fetchData(): void {
    if (!this.fabricUUIDs || this.fabricUUIDs.length < 1) {
      return;
    }

    this.loading.set(true);
    this.fabricVariationService.getForComparison(this.fabricUUIDs).subscribe({
      next: (resp: any) => {
        this.fabrics = resp.data ?? [];
        this.loading.set(false);
      },
      error: (err: any) => {
        this.loading.set(false);
        this.close();
      },
    });
  }

  getDescription(fabric: FabricVariationModel): string {
    const content = fabric.article?.description ?? '';
    return content.replace(/<[^>]*>/g, '').trim() || '-';
  }

  getCleanInstructions(fabric: FabricVariationModel): CleanInstructionModel[] {
    return fabric.article?.cleanInstructions ?? [];
  }

  getCertificationAcronyms(fabric: FabricVariationModel): string[] {
    return fabric.certifications?.map((c) => c.acronym).filter((a) => !!a) ?? [];
  }
}
